/** @jsx jsx */
import { jsx } from "@emotion/react";
import { HamburgerStyled, NoStyledBtn } from "./styles";

export type HamburgerProps = {
  toggleNav: () => void;
  isToggled: boolean;
};

const Hamburger = ({ toggleNav, isToggled }: HamburgerProps) => (
  <NoStyledBtn type="button" onClick={toggleNav} id="tour-nav-bar-item">
    <HamburgerStyled toggled={isToggled}>
      <li />
      <li />
      <li />
    </HamburgerStyled>
  </NoStyledBtn>
);

export default Hamburger;
